module.exports = __webpack_public_path__ + "img/device_1017_2_select.55311127.svg";